export default {
    message_outbox_tab_filter_by_last: "Más recientes",
    message_outbox_tab_filter_by_date: "Entre",
    message_outbox_tab_apply_filters: "Aplicar",
    message_outbox_tab_created_on: "Creado el",
    message_outbox_tab_created_by: "Creado por",
    message_outbox_tab_message: "Mensaje",
    message_outbox_tab_description: "Descripción",
    message_outbox_tab_via: "Via",
    message_outbox_tab_to: "Para",
    message_outbox_tab_title: "Comandos",
    message_outbox_tab_error_load: "Error cargando los comandos",
    message_outbox_tab_send_command: "Enviar Comando",
    message_outbox_tab_date_range: "Por favor seleccione un rango de fechas valido",
    message_outbox_tab_status: "Estado"


};